import Vue from "vue";
import VueRouter from "vue-router";
const Home = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "chunk-Home" */ "@/components/homescreens/Home.vue"
  );
const Login = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "chunk-Login" */ "@/components/identity/Login.vue"
  );
const Unauthorized = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "chunk-Unauthorized" */ "@/components/errors/Unauthorized.vue"
  );
const NotFound = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "chunk-404" */ "@/components/errors/404.vue"
  );
const MemberDirectory = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "chunk-MemberDirectory" */ "@/components/wesupport/memberDirectory.vue"
  );
const schemes = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "chunk-kitchenDisplay" */ "@/components/wesupport/scheme/schemes.vue"
  );
const History = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "chunk-orderTicket" */ "@/components/wesupport/history/components/history.vue"
  );
Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/notFound",
  },
  {
    path: "/notFound",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: Unauthorized,
  },
  {
    path: "/memberDirectory",
    name: "MemberDirectory",
    component: MemberDirectory,
  },
  {
    path: "/schemes",
    name: "Schemes",
    component: schemes,
    props: true,
  },
  {
    path: "/history",
    name: "History",
    component: History,
    props: true,
  },
  {
    path: "/member",
    name: "Member",
    component: ()=>import("@/components/wesupport/member/member.vue"),
    props: true,
  },
  {
    path: "/memberList",
    name: "MemberList",
    component: ()=>import("@/components/wesupport/member/membersList.vue"),
    props: true,
  },
  {
    path: "/paymentSuccess/:id",
    name: "PaymentSucess",
    component: ()=>import("@/components/wesupport/payment/PaymentStatus.vue"),
    props: true,
  },
  {
    path: "/paymentFailed",
    name: "PaymentFailed",
    component: ()=>import("@/components/wesupport/payment/PaymentStatus.vue"),
    props: true,
  } 
];

const router = new VueRouter({
  routes,
});

export default router;
